@include media-breakpoint-up(xl) {
    .app-nav {
        display: flex;
        max-height: none !important; //override JS style from mobile

        &__parent {
            a {
                position: relative;
                display: block;
                color: #fff;
                padding: 25px;
                @include text-size(18);
                font-weight: 500;
                text-decoration: none;

                &:after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 33.33%;
                    height: 3px;
                    background: $secondary;
                    opacity: 0;
                    transition: all 300ms;
                }
            }
        }

        &__parent-toggle {
            display: none;
        }

        &__sub {
            display: none;
            position: absolute;
            background: #fff;

            &.mega-children {
                left: 0;
                width: 100%;
                min-height: 280px;

                &.no-break {
                    left: auto;
                    min-width: 250px;
                    width: auto;
                }
            }

            &.simple-children {
                display: none;
                min-width: 250px;
                width: auto;
                min-height: 280px;

                .simple-children__links {
                    width: 250px;
                    padding: 24px;

                    a {
                        display: flex;
                        align-items: center;
                        color: $primary;
                        @include text-size(15);
                        font-weight: 600;
                        margin-bottom: 38px;
                        text-decoration: none;
						
						span.nav-child-arrow-desktop {
							background-image: url(/ui/www/assets/img/gold-arrow_short.svg);
							background-repeat: no-repeat;
							background-position: center;
							background-size: contain;
							display: inline-block;
							width: 1rem;
							height: 0.5rem;
							margin: 0 0 0.1rem 0.5rem;
						}
        
                        svg {
                            @include svg-format(16px, 16px, currentColor);
                            transform: translateX(5px);
                            transition: all 300ms;
                        }
        
                        &:hover {
                            color: $darker-gold;
							
							span.nav-child-arrow-desktop {
								background-image: url(/ui/www/assets/img/gold-arrow_long.svg);
								width: 2rem;
								height: 1rem;
							}
							
                            svg {
                                transform: translateX(10px);
                                circle {
                                    fill: $primary;
                                }
                                line {
                                    stroke: $white;
                                }
                            }
                        }
                    }
                }                
            }
        }

        &__node {
            &:hover {
                .app-nav__parent {
                    a {
                        background: #fff;
                        color: $primary;

                        &:after {
                            opacity: 1;
                            width: 100%;
                        }
                    }
                }

                .app-nav__sub {
                    display: flex;
                    animation: subNavIn 200ms linear forwards;

                    &.simple-children {
                        display: flex;
                    }
                }
            }

            &:focus-within {
                .app-nav__parent {
                    a {
                        background: #fff;
                        color: $primary;

                        &:after {
                            opacity: 1;
                            width: 100%;
                        }
                    }
                }

                .app-nav__sub {
                    display: flex;
                    animation: subNavIn 200ms linear forwards;

                    &.simple-children {
                        display: flex;
                    }
                }
            }
        }

        &__children {
            padding: 24px;
            display: flex;
            // flex-wrap: wrap;
            flex-direction: column;
            flex-grow: 1;
        }

        &__children-mobile {
            display: none;
        }

        &__child {
            margin-bottom: 20px;

            a {
                display: flex;
                align-items: center;
                color: $primary;
                @include text-size(15);
                font-weight: 700;
                text-decoration: none;

                svg {
                    width: 100%;
                    max-width: 16px;
                    max-height: 16px;
                    transform: translateX(5px);
                    transition: all 300ms;
                }

                &:hover {
                    color: $darker-gold;

                    svg {
                        transform: translateX(10px);
                        circle {
                            fill: $primary !important;
                        }
                        line {
                            stroke: #fff !important;
                        }
                    }
                }
            }
        }

        &__third-level {
            margin: 0 0 1.5rem 1rem;
            
            &:last-child {
                margin-bottom: 0;
            }

            a {
                display: inline-block;
                margin-bottom: 1rem;
                color: #000;
                text-decoration: none;
                font-size: 1rem;
                line-height: 1.5rem;
                font-weight: 400;

                &:hover {
                    text-decoration: underline;
                    color: $darker-gold;
                }
            }
        }

        &__cta {
            height: 100%;
        }
    }

    body.menu-entered .menu-overlay {
        display: block;
        animation: subNavIn 200ms linear forwards;
    }
}

.menu-overlay {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    display: none;
}

.app-nav {
    align-items: center;

    &__cta {
        position: relative;
        width: 287px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        background-size: cover;
        background-position: center;

        &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: $primary;
            opacity: .5;
        }
    }

    &__cta-content {
        position: relative;
        padding: 30px;
        color: #fff;
        z-index: 2;

        .cta-title {
            @include text-size(20);
            font-weight: 700;
            margin-bottom: 10px;
        }

        .cta-description {
            @include text-size(15);
            @include line-height(20);
            font-weight: 500;
            margin-bottom: 20px;
        }
    }
}

@include media-breakpoint-down(xl) {
    .app-nav {
        background: #fff;
        position: absolute;
        left: 0;
        top: 81px;
        width: calc(100% - 20px);
        margin-top: -2px;
        opacity: 0;
        overflow-y: auto;
        padding-bottom: 26px;
        transform: translateX(-105%);
        transition: opacity 300ms, transform 300ms;

        &.open {
            opacity: 1;
            transform: translateX(0);
        }

        &__sub {
            display: none;
        }

        &__parent-toggle {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            border-left: 2px solid #f4f4f4;

            svg {
                @include svg-format(10px, 12px, #333);
                transition: all 350ms;
            }
        }

        &__parent,
        &__child-link {
            display: flex;
            border-bottom: 2px solid #f4f4f4;

            a {
                display: block;
                flex-grow: 1;
                @include text-size(16);
                font-weight: 600;
                color: #333;
                text-decoration: none;
                padding: 1rem;
                inline-size: min-content;
                user-select: none;
            }
        }

        &__children {
            display: none;
        }

        &__node {
            &:first-of-type {
                .app-nav__parent {
                    border-top: 2px solid #f4f4f4;
                }
            }

            &.open {
                .app-nav__parent {
                    background: $quinary;
                    border: none;

                    a {
                        color: $primary;
                    }

                    .app-nav__parent-toggle {
                        background-color: $primary;

                        svg {
                            fill: #fff;
                            transform: rotate(180deg);
                        }
                    }
                }

                .app-nav__sub {
                    display: block;
                    border-bottom: 2px solid #959595;
                }
            }
        }

        &__children-mobile {
            display: block;
            padding: 15px;
            .app-nav__child {
                .app-nav__child-link {
                    .app-nav__parent-toggle {
                        border: none !important;
                        background-color: transparent !important;
                    }
                }
            }
        }

        &__child-link {
            a {
                color: $primary;
                padding: 9px 18px 9.5px 18px;
                @include text-size(15);
            }

            .app-nav__parent-toggle {
                width: 38px;

                svg {
                    fill: $primary;
                }
            }
        }

        &__child {
            &:first-of-type {
                .app-nav__child-link {
                    border: none;
                }
            }

            &.open {
                .app-nav__child-link {
                    a {
                        color: $darker-gold;
                    }
                    .app-nav__parent-toggle {
                        background: $primary;

                        svg {
                            fill: #fff;
                            transform: rotate(180deg);
                        }
                    }
                }

                .app-nav__third-level {
                    background: $quinary;
                    border: none;
                    display: block;
                    padding: 6px 0;
                    a {
                        font-weight: 500;
                        span.nav-chevron {
                            background-image: url(../assets/img/chevron-gold_mobile.svg);
                            background-repeat: no-repeat;
                            background-position: center;
                            background-size: contain;
                            display: inline-block;
                            height: 7px;
                            width: 7px;
                            margin: 0 0 0 7px;
                            rotate: 90deg;
                        }
                    }
                }
            }
        }

        .simple-children {
            padding: 15px;

            a {
                display: block;
                @include text-size(15);
                text-decoration: none;
                font-weight: 500;
                padding: 12px 18px;
                border-top: 2px solid #f4f4f4;

                svg {
                    display: none;
                }

                &:last-of-type {
                    border-bottom: 2px solid #f4f4f4;
                }
            }

            .app-nav__cta {
                padding: 15px 0 0 0;
            }
        }

        &__third-level {
            display: none;
            background: #f8f8f8;
            border: none;
            margin-left: 1rem;

            a {
                padding: 11px 22px;
                display: block;
                @include text-size(15);
                color: $primary;
                text-decoration: none;
            }
        }

        &__cta {
            background-image: none !important;
            width: 100%;
            margin-top: 5px;
            padding: 0 15px 25px 15px;
            border-bottom: 2px solid #f4f4f4;

            &:after {
                display: none;
            }
        }

        &__cta-content {
            background: $primary;
            padding: 15px 25px 25px 25px;
        }
    }

    body.menu-open .menu-overlay {
        display: block;
        animation: subNavIn 200ms linear forwards;
    }
}

@keyframes subNavIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}